import React, { useState } from "react";
import { Tag, Tooltip, Spin } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined, LoadingOutlined } from "@ant-design/icons"; // Import Icons
import styles from "./CustomCard.module.scss";

const CustomCard = ({
  title,
  value,
  percentage,
  isPositive,
  imageIcon,
  colorCode,
  className,
  dmCost, // Add dmCost prop
  loading,
}) => {
  const [isHovered, setIsHovered] = useState(false);
       const formatValue = (value, key) => {
  if (!value) return "--";
        
  const number = parseFloat(value.replace(/,/g, ""));
  if (isNaN(number)) return "--";

  // For percentage (no division)
  if (key === "DM%") {
    return number +"%";
  }

  // Divide by 1000 and format again
  const divided = number;

  return divided.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};


  return (
    <div 
      className={`${styles.card} ${className || ''} relative ${title === "DM%" && isHovered ? 'ring-2 ring-blue-500' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Header Section */}
      <div className="flex justify-center gap-2 bg-[#0091D5] rounded-[12px] rounded-bl-none rounded-br-none p-2 ">
        {imageIcon && (
          <img
            src={imageIcon}
            alt="icon"
            className="w-[20px] h-[20px]"
          />
        )}
        <h1 className={styles.heading}>{title}</h1>
      </div>

      {/* Value and Percentage */}
      <div className={styles.valueContainer}>
        {loading ? (
          <div className="flex items-center gap-2 py-1.5">
            <Spin
              indicator={
                <LoadingOutlined style={{ fontSize: 18, color: '#0091D5' }} spin />
              }
            />
            <span className="text-[15px] font-medium text-[#0091D5] tracking-wide animate-pulse">
              Calculating…
            </span>
          </div>
        ) : (
          <h1
            className={styles.value}
            style={{ color: colorCode }}
          >
            {formatValue(value, title)}
          </h1>
        )}

        {/* Percentage Change Tag */}
        {!loading && percentage && (
          <Tag
            className={`${styles.customTag} ${
              isPositive
                ? 'bg-green-100 text-green-700'
                : 'bg-red-100 text-red-700'
            }`}
            icon={
              isPositive ? (
                <ArrowUpOutlined />
              ) : (
                <ArrowDownOutlined />
              )
            }
          >
            {percentage}%
          </Tag>
        )}
      </div>

      {/* Tooltip for DM% card showing dm_cost */}
      {title === "DM%" && isHovered && dmCost && (
        <div 
          className="absolute -bottom-10 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white px-3 py-2 rounded-lg shadow-xl z-50 whitespace-nowrap"
          style={{ fontSize: '12px' }}
        >
          {/* DM Cost: {parseFloat(dmCost).toLocaleString('en-IN', { */}
          DM Cost: {parseFloat(dmCost.toString().replace(/,/g, "")).toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </div>
      )}
    </div>
  );
};

export default CustomCard;
